import { useEffect } from 'react';
import ReactPlayer from 'react-player';
import { useParams } from 'react-router';

import { Avatar } from '@/components/Avatar';
import { Icon } from '@/components/Icon';
import { Spinner } from '@/components/Spinner';
import { useResponsive } from '@/hooks/useResponsive';
import { useTitle } from '@/hooks/useTitle';
import { Flex } from '@/layouts/Flex';
import { Colors } from '@/plugins/data/colors';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { requestReview } from '@/store/modules/reviews';
import styles from './styles.module.scss';

export function ReviewPage() {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const { isDesktop } = useResponsive();
  const { item, loading } = useAppSelector((state) => state.reviews);

  useTitle(`DienTEA | ${item ? item.title : 'Detalles del video'}`);

  useEffect(() => {
    if (id && (!item || item.id !== id)) {
      dispatch(requestReview(id));
    }
  }, [item, id, dispatch]);

  if (loading || !item) {
    return <Spinner />;
  }

  return (
    <div className={styles.container}>
      <h1>{item.title}</h1>
      <Flex justifyContent='space-between' alignItems='flex-end' flexWrap='wrap'>
        <Flex alignItems='center' gap={10}>
          <Avatar src={item.author?.avatar} size={36} />
          <span>{item.author ? `${item.author.name} ${item.author.surname}` : 'Autor desconocido'}</span>
        </Flex>
        <Flex alignItems='center' gap={12} className={styles.dateContainer}>
          <Icon name='calendar' size={18} color={Colors.primaryDark} />
          <span>{new Date(item.createdAt).toLocaleDateString('es')}</span>
        </Flex>
      </Flex>

      {item.categories.length > 0 ? (
        <Flex flexWrap='wrap' alignItems='center' gap={12} className={styles.categoriesContainer}>
          {item.categories.map((category) => (
            <Flex key={category.id} className={styles.category} alignItems='center' gap={6}>
              <Icon name='tag' size={16} color={Colors.secondaryDark} />
              <span>{category.name}</span>
            </Flex>
          ))}
        </Flex>
      ) : null}

      <Flex
        flexDirection={isDesktop ? 'row' : 'column'}
        justifyContent='space-between'
        gap={20}
        className={styles.content}>
        <p>{item.content}</p>
        <ReactPlayer src={item.url} fallback={<Spinner />} controls width={'100%'} height={'100%'} />
      </Flex>
    </div>
  );
}
